<template>
  <div class="memo">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card
          v-for="villager in villagers"
          :set="set"
          :key="villager.id"
          :card="villager"
          @card-clicked="handleClick"
          :active="
          firstPick === villager || secondPick === villager || villager.matched
        "
      />
    </div>
    <div
        class="w-full flex justify-center items-center z-0 text-2xl text-gray font-bold "
    >
      Próby: {{ turns }}
    </div>
    <Modal v-show="done" :turns="turns" @click="resetGame" />
  </div>
</template>

<script>
import Card from "./components/Card.vue";
import Modal from "./components/Modal.vue";
import {getRandomOtherThan} from "@/helpers";
export default {
  name: "MemoComponent",
  components: {
    Card,
    Modal
  },
  data() {
    return {
      set: null,
      images: [
        { img: "memo-01.jpg" },
        { img: "memo-02.jpg" },
        { img: "memo-03.jpg" },
        { img: "memo-04.jpg" },
        { img: "memo-05.jpg" },
        { img: "memo-06.jpg" },
        { img: "memo-07.jpg" },
        { img: "memo-08.jpg" },
      ],
      villagers: [],
      firstPick: null,
      secondPick: null,
      turns: 0,
      done: false
    };
  },
  methods: {
    handleClick(card) {
      this.firstPick ? (this.secondPick = card) : (this.firstPick = card);
      if (this.firstPick && this.secondPick) {
        if (this.firstPick.img === this.secondPick.img) {
          const ind1 = this.villagers.indexOf(card);
          const ind2 = this.villagers.indexOf(this.firstPick);
          this.villagers[ind1].matched = true;
          this.villagers[ind2].matched = true;
          this.resetActive();
        } else {
          this.resetActive();
        }
        this.turns++;
      }
      this.checkIfCompleted();
    },
    resetActive() {
      setTimeout(() => {
        this.firstPick = null;
        this.secondPick = null;
      }, 500);
    },
    shuffle() {
      this.villagers.sort(() => Math.random() - 0.5);
    },
    checkIfCompleted(){
      if(this.villagers.every(villager => villager.matched)) this.done = true;
    },
    resetGame(){
      this.firstPick = null;
      this.secondPick = null;
      this.turns = 0;
      this.done = false;
      this.set = getRandomOtherThan(this.set, 1, 6);
      this.villagers.forEach(v => v.matched = false);
      setTimeout(() => {
        this.shuffle();
      }, 500);
    }
  },
  mounted() {
    this.villagers = [...this.images, ...this.images].map(
        (villager, index) => ({
          ...villager,
          matched: false,
          id: index,
        })
    );
    this.resetGame()
  },
};
</script>

<style>
.memo {
  display: flex;           /* establish flex container */
  flex-direction: column;  /* make main axis vertical */
  justify-content: center; /* center items vertically, in this case */
  align-items: center;     /* center items horizontally, in this case */
  margin:0 auto;
  padding:40px;
  border-radius: 10px;
  max-width: 1000px;
  min-height: 650px;
  overflow: hidden;
  background-size:cover;
  background-position: center center;
  @apply bg-gray-100
}
</style>